import {IrrigationResultsRow} from "./irrigation-results-row";

export class IrrigationRecord {

  id: string;
  date: string;
  orchard_et_gpa: number;             // gallons per acre
  orchard_et_cumulative: number;      // gallons per acre
  rainfall_in: number;                // inches
  rainfall_gpa: number;               // gallons per acre
  rainfall_cumulative: number;        // gallons per acre
  rainfall_edited: boolean;           // value has been entered by user
  irrigation: number;                 // gallons per acre
  irrigation_cumulative: number;      // gallons per acre
  irrigation_edited: boolean;         // value has been entered by user
  water_balance_daily: number;        // gallons per acre
  water_balance_cumulative: number;   // gallons per acre
  should_irrigate: boolean;
  irrigation_recommendation: string;

  constructor(row: IrrigationResultsRow) {
    this.id = row.date; // YYYY-MM-DD
    this.date = row.date;
    this.water_balance_daily = row.water_balance_daily;
    this.water_balance_cumulative = row.water_balance_cumulative;
    this.orchard_et_gpa = row.orchard_et_gpa;
    this.orchard_et_cumulative = row.orchard_et_cumulative;
    this.rainfall_gpa = row.rainfall_gpa;
    this.rainfall_cumulative = row.rainfall_cumulative;
    this.irrigation = row.irrigation;
    this.irrigation_cumulative = row.irrigation_cumulative;
    this.rainfall_edited = row.rainfall_edited;
    this.irrigation_edited = row.irrigation_edited;
    this.should_irrigate = row.should_irrigate;
    this.irrigation_recommendation = row.irrigation_recommendation;

    if (this.rainfall_edited === undefined) {
      this.rainfall_edited = false;
    }
    if (this.irrigation_edited === undefined) {
      this.irrigation_edited = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/irrigation-record.ts